export default {
  'thisWeek': 'This week',
  'noJobs': 'No jobs',
  'noJobsDesc': 'No jobs to show here. Try changing your selected state or search selection.',
  'noCompanies': 'No companies',
  'noCompaniesDesc': 'No companies to show here. Try changing your selected state or search selection.',
  'cateAllJobs': 'All Jobs',
  'cateAll': 'All',
  'cateApplied': 'Applied',
  'active': 'Active',
  'cateHired': 'Hired',
  'rewardInHVT': 'Reward in Crypto',
  'donateInHVT': 'Donation in HVT',
  'rewardTooltip': 'Apply or refer somebody to this job to <br> earn rewards in BTC, STX, or VIBES.',
  'donateTooltip': 'Every successful hire creates a donation <br> for charity, free from HireVibes.',
  'apply': 'Apply',
  'viewOffer': 'View Offer',
  'accept': 'Accept',
  'accepted': 'Accepted',
  'reject': 'Reject',
  'viewApplication': 'View Application',
  'referSomebody': 'Refer Somebody',
  'view': 'View',
  'views': 'VIEWS',
  'hired': 'HIRED',
  'applicant': 'APPLICANT',
  'applicants': 'APPLICANTS',
  'profilePrivateAlert': 'This profile is private! To make your profile private go to your <br/> profile and switch the toggle.',
  'contact': 'Contact',
  'referForJob': 'Refer For Job',
  'referForJobs': 'Refer for jobs',
  'referral': 'Referral',
  'referralInfo': 'Enter the position to refer this jobseeker for the job. If they use your referral then we\'ll credit you. No spamming please!',
  'submitReferral': 'Submit Referral',
  'submitReferrals': 'Submit Referrals',
  'submitApplication': 'Submit Application',
  'referralSuccessful': 'Referrals Successful',
  'referralsSubmitted': 'Referrals Submitted',
  'socialProfiles': 'Social Profiles',
  'jobPreferences': 'Job preferences',
  'saveJobPreferences': 'SAVE JOB PREFERENCES',
  'roles': 'Roles',
  'salary': 'Salary',
  'locations': 'Locations',
  'contractTypes': 'Job Types',
  'noticePeriod': 'Notice Period',
  'resume': 'Resume',
  'attached': 'Attached',
  'unattached': 'Unattached',
  'applied': 'Applied',
  'interviewing': 'Interviewing',
  'rejected': 'Rejected',
  'applicationDetails': 'Application Details',
  'applicationSubmitted': 'Application Submitted',
  'offerDetails': 'Offer Details',
  'jobOfferAccepted': 'Job offer accepted',
  'jobOfferRejected': 'Job offer rejected',
  'areYouSure': 'ARE YOU SURE?',
  'confirmTextForOfferAccept': 'Are you sure you want to accept this offer? We’ll notify the Hirer immediately about your decision. Any questions message us by clicking the green chat widget below.',
  'confirmTextForDelete': 'Are you sure you want to delete this job?',
  'confirmTextForOfferDecline': 'Are you sure you want to decline this offer? We’ll notify the Hirer immediately about your decision.',
  'addReferralTxt': 'Enter the jobseekers name or email address below to refer them for this job. If they use your referral then we\'ll credit you. No spamming please!',
  'enterEmail': 'Press <b>enter</b> to add an email address',
  'addUser': 'Add user',
  'jobseekerNameOrEmail': 'Jobseeker name or email',
  'roleContract': 'Contract',
  'roleRemote': 'Remote',
  'rolePermanent': 'Permanent',
  'roleFreelance': 'Freelance',
  'posted': 'Posted',
  'tooltipSendMsg': 'Send a message to this user',
  'tooltipEarn': 'Earn 1.75% of the jobs pay and another 1.75% goes to successful jobseeker',
  'donationReward': 'Free Donation',
  'closed': 'Closed',
  'jobs': 'Jobs',
  'companies': 'Companies',
  'inviteCompany': 'Invite Company',
  'createCompany': 'Create Company',
  'invitationEmailSent': 'An invitation email has been sent!',
  'invitationEmail': 'Invitation Email',
  'selectJobBoard': 'Select Job Board',
  'companyEmail': 'Company Email',
  'enterTheEmail': 'Enter the email address for the the companies you would like to invite to HireVibes',
  'enteremail': 'Enter email',
  'pleaseEnter': 'Please <strong>enter</strong> to add an email address',
  'jobBoardRequired': 'Job board is required',
  'optIn': 'Opt-in to be considered for other jobs in this company’s network',
  'filterJobseekers': 'Filter Jobseekers by Jobs Boards',
  'allEco': 'All Ecosystems',
  'iWantToBe': 'I want to be added to Talent Pools in this company’s network',
  'attachCv': 'ATTACH CV TO COMPLETE APPLICATION'
}



// WEBPACK FOOTER //
// ./src/i18n/en/jobs.js